import WorkOrder from "./WorkOrder";

export default WorkOrder;
